import { render, staticRenderFns } from "./ExchangeCopyFile.vue?vue&type=template&id=4bf7d549&scoped=true&"
import script from "./ExchangeCopyFile.vue?vue&type=script&lang=js&"
export * from "./ExchangeCopyFile.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeCopyFile.vue?vue&type=style&index=0&id=4bf7d549&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf7d549",
  null
  
)

export default component.exports